import React, { Component, Fragment } from 'react';
import { Input, Form, Icon, AutoComplete } from 'antd';
import { HFRegex } from 'store/utility';
// import styles from './ListSearch.module.css'

const { Search } = Input;
const { Item } = Form;

class ListSearch extends Component {
  state = {
    validationState: null,
    dataSource: [],
  };

  onSearchHandler = e => {
    const { form } = this.props;
    e.preventDefault();
    form.validateFields((error, value) => {
      const { search } = value;
      if (error) return;
      if (!search) return;
      const HFID = search;
      let id = HFID.match(/^\d+$/) ? parseInt(HFID, 10) : parseInt(HFID.slice(2), 10);
      this.props.onSearchHandler(id, HFID, form);
    });
  };

  autocompleteHandler = value => {
    const count = 5 - value.length;
    if (!value || isNaN(parseInt(value, 10)) || count < 0) {
      this.setState(prev => ({ ...prev, dataSource: [] }));
    } else {
      const generated = `HF${'0'.repeat(count)}${value}`;
      this.setState(prev => ({ ...prev, dataSource: [generated] }));
    }
  };

  saveRefSearch = search => (this.search = search);

  renderSearch = () => {
    const { validationState } = this.state;
    let style = { marginRight: 15 };

    if (validationState === 'check-circle') style = { marginRight: 10, color: 'lightgreen' };
    else if (validationState === 'exclamation-circle') style = { marginRight: 10, color: 'red' };

    const suffix = validationState ? <Icon type={validationState} key={1} style={style} /> : null;
    return (
      <AutoComplete
        size="large"
        dataSource={this.state.dataSource}
        style={{ width: 400 }}
        onChange={this.autocompleteHandler}
      >
        <Search
          id="list-search-form"
          placeholder="Input list ID"
          size="large"
          suffix={suffix}
          style={{ width: 400 }}
          onPressEnter={this.onSearchHandler}
        />
      </AutoComplete>
    );
  };

  checkListIDValidator = (_r, HFID, callback) => {
    if (!HFID) {
      this.setState(prev => ({ ...prev, validationState: null }));
      return callback();
    }
    if (HFID.match(/^\d+$/)) {
      this.setState(prev => ({ ...prev, validationState: 'check-circle' }));
      return callback();
    }
    if (!HFID.match(HFRegex())) {
      this.setState(prev => ({ ...prev, validationState: 'exclamation-circle' }));
      return callback('Invalid Hafary ID, should be format: HF*****');
    }
    this.setState(prev => ({ ...prev, validationState: 'check-circle' }));
    return callback();
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;

    return (
      <Fragment>
        <Item style={{ float: 'left', margin: 0 }}>
          {getFieldDecorator('search', {
            validate: [
              {
                trigger: 'onChange',
                rules: [{ validator: this.checkListIDValidator }],
              },
            ],
          })(this.renderSearch())}
        </Item>
      </Fragment>
    );
  }
}

export default Form.create()(ListSearch);



// WEBPACK FOOTER //
// ./src/components/List/ListSearch.js